module.exports = __webpack_public_path__ + "img/404.e44592b7.svg";